import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type LantechMachine } from "@packsize/schemas/machines";

import { getLantechCaseSealerMachines } from "@/api/machines/lantech-case-sealer-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { LANTECH_CASE_SEALER_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getLantechCaseSealerMachinesQuery = <TData = LantechMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: LANTECH_CASE_SEALER_MACHINES_QUERY_KEY,
	queryFn: getLantechCaseSealerMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useLantechCaseSealerMachines = (
	options?: UseMachinesQueryOptions<LantechMachine[], Error>,
): UseQueryResult<LantechMachine[], Error> => {
	return useQuery<LantechMachine[], Error>(getLantechCaseSealerMachinesQuery(options));
};
